export default "__VITE_ASSET__5924e35b__"